<template>
	<div class="w-full gap-3 flex flex-column">
		<div class="w-full flex flex-column surface-0 border-round-xl p-3">
			<div class="w-full flex flex-column gap-2">
                <div class="w-full flex">
                    <span class="text-900 font-medium text-lg xl:text-xl">
                        Поиск по стране
                    </span>
                </div>
				<div class="w-full flex">
                    <InputText v-model="searchText" :placeholder="t('search_placeholder')"
                        class="w-full px-3 py-3 surface-border border-round-xl border-2" size="large" />
				</div>
			</div>
		</div>
		<div v-if="!countryCode" class="w-full flex mb-2">
			<MobMenu :items="[]">
				<template v-slot:body>
					<div v-for="item of countriesFiltered" @click="selectCountry(item.code)" :key="item.code">
						<div class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1">
							<div class="flex mr-3 align-items-center">
								<AvatarGroup>
									<Avatar :image="`/images/svg/countries/${item.code.toUpperCase()}.svg`"
										size="small" shape="circle" class="border-1 border-100"/>
								</AvatarGroup>
							</div>
							<div class="flex flex-1 justify-content-left align-items-center">
								{{ (item.title_ru) ? item.title_ru : item.title}}
							</div>
							<div class="flex justify-content-right align-items-center">
								<i class="text-blue-500 ml-2 pi pi-angle-right" />
							</div>
						</div>
					</div>

				</template>
			</MobMenu>
		</div>
		<div v-else class="w-full flex mb-2">
			<Button class="border-round-xl surface-0" @click="resetCountry()" size="small"
				:label="getCountryTitle" icon="pi pi-times" iconPos="right" severity="secondary"/>
		</div>

        <div v-if="products && products.length" class="w-full flex mb-2">
            <span v-if="total" class="text-600 text-sm xl:text-md">
                Найдено тарифов: {{ total || 0 }}
            </span>
 			<span v-else class="text-600 text-sm xl:text-md">
				{{ t('no_products') }}
			</span>
        </div>

		<!-- Список продуктов -->
		<div v-if="loading" class="w-full">
			<Skeleton v-for="i in 6" :key="i" height="4rem" class="mb-2 border-round-xl" />
		</div>

		<div v-else class="w-full">
			<div v-if="filtered && filtered.length > 0">


				<div v-for="(p, idx) in filtered" :key="p.id || idx" @click="openPopup(p)"
                    class="w-fill flex flex-column surface-0 overflow-hidden border-round-xl p-3 mb-2">

					<div class="flex flex-row justify-content-between align-items-start gap-3">
						<div class="flex-1">
							<div class="flex gap-2 align-items-center mb-2">
								<AvatarGroup>
									<Avatar :image="getProviderImage(p)" size="small" shape="circle" class="border-0"/>
								</AvatarGroup>
								<span class="text-800 font-semibold text-sm xl:text-base">
									<!-- {{ getTitle(p) }} -->
									{{ selectedPlanDetails(p, 'PLAN_TITLE') }}
								</span>
								<span v-if="p.category" class="text-500 text-xs border-1 surface-border border-round-md px-2 py-1">{{ p.category }}</span>
							</div>
							<div class="flex gap-3 text-700 text-xs xl:text-sm">
								<span v-if="getDataAmount(p)">{{ t('data') }}: {{ getDataAmount(p) }}</span>
								<span v-if="getValidity(p)">{{ t('validity') }}: {{ getValidity(p) }}</span>
								<span v-if="getProviderName(p)">{{ t('provider') }}: {{ getProviderName(p) }}</span>
							</div>
							<div class="flex flex-column gap-1 text-700 text-sm mt-2">
								<!-- {{ selectedPlanDetails(p, 'PLAN_TITLE') }} <br/> -->
								{{ selectedPlanDetails(p, 'PLAN_VALIDITY') }} <br/>
								{{ selectedPlanDetails(p, 'PLAN_DATA_LIMIT') }} {{ selectedPlanDetails(p, 'PLAN_DATA_UNIT') }}
							</div>
							<!-- <AvatarGroup>
								<Avatar v-for="item in normalizeCountries(p)" :key="item.code || item"
									:image="`/images/svg/countries/${item.toUpperCase()}.svg`"
									size="small" shape="circle" class="border-0"/>
							</AvatarGroup> -->
						</div>
						<div class="flex flex-column align-items-end gap-2">
							<div class="inline-block text-800 font-medium text-base xl:text-xl">
								{{ formatPrice(p) }}
							</div>
						</div>
					</div>
					<div v-if="networksOpen[p.id]" class="mt-2">
						<div v-if="networksLoading[p.id]">
							<Skeleton height="3rem" class="mb-2 border-round-md" />
							<Skeleton height="3rem" class="mb-2 border-round-md" />
						</div>
						<div v-else-if="networksByProduct[p.id] && networksByProduct[p.id].length">
							<div class="flex flex-row flex-wrap gap-2">
								<span v-for="n in networksByProduct[p.id]"
											:key="n.code || n.id || n.name"
											class="text-700 text-xs border-1 surface-border border-round-md px-2 py-1">
									{{ n.title || n.name || n.code }}
								</span>
							</div>
						</div>
						<div v-else class="text-500 text-sm">{{ t('no_network_data') }}</div>
					</div>
				</div>

			</div>
			<div v-if="products && products.length && !filtered" class="w-full">
				<span class="block text-800 mb-3">{{ t('no_products') }}</span>
			</div>

			<div class="w-full mt-2">
				<Paginator v-if="total && total>limit"
					v-model:first="skip" :rows="limit" :totalRecords="total"
					:rowsPerPageOptions="[10, 20, 30, 50]"
					template="PrevPageLink PageLinks NextPageLink" />
			</div>
		</div>
	</div>

    <Dialog class="w-full border-none" modal
        v-model:visible="popupVisible" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">
        <template #header>
            <span class="text-lg font-medium">Подробности</span>
        </template> 


        <div v-if="selectedProduct" class="w-full">
			<div class="w-full surface-0 border-round-xl p-3 mb-3">
				<div class="flex flex-column gap-2">
					<span class="text-800 font-semibold text-base">{{ getTitle(selectedProduct) }}</span>
					<div class="flex gap-2 align-items-center">
						<span v-if="selectedProduct.category" class="text-500 text-xs border-1 surface-border border-round-md px-2 py-1">{{ selectedProduct.category }}</span>
						<span class="text-800 font-medium">{{ formatPrice(selectedProduct) }}</span>
					</div>
					<div class="flex flex-column gap-1 text-700 text-sm">
						<span v-if="getDataAmount(selectedProduct)">{{ t('data') }}: {{ getDataAmount(selectedProduct) }}</span>
						<span v-if="getValidity(selectedProduct)">{{ t('validity') }}: {{ getValidity(selectedProduct) }}</span>
						<span v-if="getProviderName(selectedProduct)">{{ t('provider') }}: {{ getProviderName(selectedProduct) }}</span>
					</div>
					<div v-if="selectedProduct.countries || selectedProduct.coverage" class="mt-2">
						<span class="text-700 text-sm mb-2 inline-block">Страны</span>
						<div class="flex flex-row flex-wrap gap-2">
							<span v-for="cc in normalizeCountries(selectedProduct)" :key="cc"
								  class="text-700 text-xs border-1 surface-border border-round-md px-2 py-1">
								{{ getCountryTitleByCode(cc) }}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>

        <template #footer>
            <div class="field w-full">
				<Button @click="Order()" label="Заказать" :loading="loadingOrder" :disabled="loading || loadingOrder || !selectedProduct"
                    class="w-full p-button-primary bg-primary text-white border-none border-round-xl" />
            </div>
		</template>
        </Dialog>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import countriesJson from '@/assets/json/countries.json'
import MobMenu from '@/components/sides/menu/MobMenu.vue'

export default {
	name: 'EsimFilter',
	data() {
		return {
			loading: false,
			products: [],
			searchText: '',
			countryCode: '',
			category: '',
			sort: 'default',
			// пагинация
			total: 0,
			limit: 10,
			skip: 0,
			categories: [],
			countriesOptions: [],
			networksOpen: {},
			networksByProduct: {},
			networksLoading: {},
			popupVisible: false,
			selectedProduct: null,
			loadingOrder: false,
			orderResult: null,
			wallet: null,
		}
	},
	components: {
		MobMenu,
	},
	methods: {
		t(key) {
			const map = {
				search_placeholder: 'Например, Индонезия',
				country_any: 'Любая страна',
				category_any: 'Любая категория',
				sort_default: 'Сортировка',
				sort_price_asc: 'Цена ↑',
				sort_price_desc: 'Цена ↓',
				sort_data_desc: 'Трафик ↓',
				data: 'Трафик',
				validity: 'Срок',
				provider: 'Провайдер',
				show_coverage: 'Покрытие',
				hide_coverage: 'Скрыть покрытие',
				no_network_data: 'Нет данных о покрытии',
				no_products: 'Тарифы не найдены',
			}
			return map[key] || key
		},
		selectCountry(code) {
			this.countryCode = code
			this.skip = 0
			this.fetchProducts()
		},
		resetCountry() {
			this.searchText = ''
			this.countryCode = ''
			this.skip = 0
			this.products = []
			this.filterd = []
		},
		async fetchProducts() {
			this.loading = true
			const limit = this.limit
			const skip = this.skip
			const filter = this.buildFilter()
			const sort = this.buildSort()
			try {
				const api = new Connect()
				const res = await api.GetEsimProducts(limit, skip, filter, sort)
				const items = res && res.result !== false ? (res.items || res.data || res) : []
				this.products = Array.isArray(items) ? items : []
                this.total = res?.total || null
			} finally {
				this.loading = false
			}
			console.log('>>>>>>>>:', this.products)
		},
		buildFilter() {
			const filter = {}
			// if (this.searchText && this.searchText.trim().length > 0) filter.q = this.searchText.trim()
			if (this.countryCode) filter.country = this.countryCode
			if (this.category) filter.category = this.category
			return filter
		},
		buildSort() {
			if (this.sort === 'price_asc') return { price: 1 }
			if (this.sort === 'price_desc') return { price: -1 }
			if (this.sort === 'data_desc') return { data: -1 }
			return {}
		},
		collectCountries() {
			const setCountries = new Map()
			// из файла стран
			if (Array.isArray(countriesJson)) {
				countriesJson.forEach(c => {
					if (c && c.iso) setCountries.set(c.iso, { code: c.iso, title: c.name || c.iso, title_ru: c.name_ru || c.iso })
				})
			}
			this.countriesOptions = Array.from(setCountries.values()).sort((a,b)=>a.title.localeCompare(b.title))
		},
		onSearchInput() {
			clearTimeout(this._searchTimer)
			this._searchTimer = setTimeout(()=>{ this.searchText = this.searchText.trim() }, 200)
		},
		matchesSearch(p) {
			if (!this.searchText) return true
			const q = this.searchText.toLowerCase()
			const parts = [this.getTitle(p), this.getProviderName(p), p?.description]
			return parts.filter(Boolean).some(v => String(v).toLowerCase().includes(q))
		},
		matchesCountry(p) {
			if (!this.countryCode) return true
			const cs = p?.countries || p?.coverage || []
			return (cs.countries && Array.isArray(cs.countries)) ? cs.countries.includes(this.countryCode) : false
		},
		matchesCategory(p) {
			if (!this.category) return true
			return p?.category === this.category
		},
		sortItems(arr) {
			if (this.sort === 'price_asc') return [...arr].sort((a,b)=> (this.getPrice(a) - this.getPrice(b)))
			if (this.sort === 'price_desc') return [...arr].sort((a,b)=> (this.getPrice(b) - this.getPrice(a)))
			if (this.sort === 'data_desc') return [...arr].sort((a,b)=> (this.getDataValue(b) - this.getDataValue(a)))
			return arr
		},
		getTitle(p) {
			return p?.title || p?.name || '-'
		},
		getProviderName(p) {
			return p?.provider?.title || p?.provider?.name || p?.provider_name || ''
		},
		getProviderImage(p) {
			return p?.provider?.image || p?.provider?.logo || ''
		},
		getDataAmount(p) {
			const val = this.getDataValue(p)
			if (!val) return ''
			return `${val} GB`
		},
		getDataValue(p) {
			const v = p?.data || p?.data_gb || p?.traffic_gb || 0
			return Number(v) || 0
		},
		getValidity(p) {
			const v = p?.validity || p?.days || p?.validity_days
			return v ? `${v} дней` : ''
		},
		getPrice(p) {
			const price = p?.pricing && p.pricing.retail ? p.pricing.retail : 0
			return Number(price) || 0
		},
		formatPrice(p) {
			const price = this.getPrice(p)
			const currency = p?.pricing && p.pricing.currency ? p.pricing.currency : (p?.currency_code || 'USD')
			const helper = new Helper()
			try {
				return helper.format_amount(price, currency, (currency==='rub'||currency==='idr') ? 0 : 2)
			} catch(e) {
				return `${price} ${currency}`
			}
		},
		async toggleNetworks(p) {
			const pid = p?.id
			if (!pid) return
			if (this.networksOpen[pid]) {
				this.$set(this.networksOpen, pid, false)
				return
			}
			this.$set(this.networksOpen, pid, true)
			if (!this.networksByProduct[pid]) {
				this.$set(this.networksLoading, pid, true)
				try {
					const api = new Connect()
					const res = await api.GetEsimNetworks(pid)
					const items = res && res.result !== false ? (res.items || res.data || res) : []
					const normalized = Array.isArray(items) ? items.map(x=>({
						code: x.code || x.iso || x.id,
						title: x.title || x.name || x.country || x.code,
					})) : []
					this.$set(this.networksByProduct, pid, normalized)
				} finally {
					this.$set(this.networksLoading, pid, false)
				}
			}
		},
		openPopup(p) {
			this.selectedProduct = p
			this.popupVisible = true
		},
		normalizeCountries(p) {
			const cs = p?.countries || p?.coverage || []
			if (Array.isArray(cs)) return cs
			if (cs && Array.isArray(cs.countries)) return cs.countries
			return []
		},
		getCountryTitleByCode(code) {
			if (!code) return ''
			code = code.toUpperCase()
			const found = this.countriesOptions.find(c=>c.code===code)
			return found ? found.title : code
		},
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
		async Order() {
			if (!this.selectedProduct || this.loadingOrder) return
			this.loadingOrder = true
			try {
				const api = new Connect()
				const product_id = this.selectedProduct.id
				const product_category = 'data'
				const res = await api.CreateEsimOrder(product_id, product_category)
                if(res.result && res.data) this.orderResult = res
                else {
                    if(res.message) this.showMess('error', 'Ошибка', res.message)
                    else this.showMess('error', 'Ошибка', 'Не удалось создать заказ')
                }
				// this.popupVisible = false // при необходимости закрыть попап
			} finally {
				this.loadingOrder = false
			}
		},
		// Возвращает value по ключу (name) из массива productDetails выбранного продукта
		selectedPlanDetails(el, code) {
			if (!el || !Array.isArray(el.productDetails)) return null
			const item = el.productDetails.find(d => (d.name || '').trim() === code)
			return item ? item.value : null
		}
	},
	computed: {
        screenSize() { return this.$store.getters.StateScreenSize },
		wallets() { return this.$store.getters.StateWallets },
		countriesFiltered() {
			const q = (this.searchText || '').trim().toLowerCase()
			if (!q) return this.countriesOptions
			return this.countriesOptions.filter(c => {
				const title = (c.title || c.code || '').toLowerCase()
				const titleRu = (c.title_ru || c.code || '').toLowerCase()
				return title.includes(q) || titleRu.includes(q)
			})
		},
		filtered() {
			// серверная фильтрация — просто отображаем загруженные продукты
			return this.products
		},
		getCountryTitle() {
			if (!this.countryCode) return ''
			const code = this.countryCode.toUpperCase()
			const found = this.countriesOptions.find(c=>c.code===code)
			return found ? (found.title_ru || found.title) : this.countryCode
		},
	},
	watch: {
		wallets: {
            handler(list) {
                if(!list || !Array.isArray(list)) return
                this.wallet = list.find(wallet => wallet.type === 'vcard')
            },
            immediate: true
        },
		skip() {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			this.fetchProducts()
		},
		// countryCode() {
		// 	this.skip = 0
		// 	this.fetchProducts()
		// },
		category() {
			this.skip = 0
			this.fetchProducts()
		},
		sort() {
			this.skip = 0
			this.fetchProducts()
		}
	},
	async beforeCreate() {
		this.helper = new Helper()
	},
	async mounted() {
		// await this.fetchProducts()
		this.collectCountries()
	}
}
</script>
